export class TranslationView {
    selected: boolean;
    id: number;
    languageTranslationId: string;
    languageCode: string;
    languageName: string;
    translation: string;
    nameId: number;
}
